import React from 'react';
import { TQueueCallSuggestion, TVoiceSuggestionOnSelect, } from './voice-suggestion.utils';
import { InboxIcon, } from '@Assets/icons';
import { IconText, } from '@Components';
import { IAuth, IVoiceAsteriskStore, } from '@Store';
import { DirectionEnum, } from 'atlas-shared';

interface IProps {
  auth: IAuth;
  voice_asterisks: IVoiceAsteriskStore;
  onSelect: TVoiceSuggestionOnSelect;
  queue: TQueueCallSuggestion;
  callBtn: React.ReactNode;
}

export const VoiceSuggestionQueue = React.memo(({ auth, voice_asterisks, queue, onSelect, callBtn, }: IProps) => {

  return <>
    <div className={`li-content${queue.selectable ? ' clickable' : ''} voice-suggestion-queue`} onClick={() => {
      if (queue.selectable) {

        onSelect([{
          direction: DirectionEnum.Internal,
          title: queue.title,
          voice_asterisk_id: -1,
          numbers: [`q-${queue.id}`, ],
          agentprofile_id: auth.user_status.agentprofile_id || 0,
          queue_id: queue?.id,
        }, ], true);
      }
    }}>
      <IconText icon={InboxIcon} text={queue.title} />
      {callBtn}
    </div>
  </>;
});
